import { render, staticRenderFns } from "./details-page.vue?vue&type=template&id=2299bd03&"
import script from "./details-page.vue?vue&type=script&lang=js&"
export * from "./details-page.vue?vue&type=script&lang=js&"
import style0 from "./details-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports